import constants from './constants';
import {getSanitizedSchedule} from './../scheduler/utils';

const initialState = {
  error: null,
  pending: false,
  data: {},
  isSuccesMessageVisible: false,
  pickupSchedule: {},
  calendarContent: '',
  eventName: '',
  isTimeProposal: false,
  isBooked: false
}

const createSchedule = (state = initialState, action) => {
  switch (action.type) {
    case `${constants.GET_PICKUP_DATA}_STARTED`:
    case `${constants.SEND_PICKUP_DATA}_STARTED`:
    case `${constants.PROPOSE_NEW_TIME}_STARTED`:
      return {...state, pending: true}

    case `${constants.GET_PICKUP_DATA}_ENDED`: {
      const {
        receiver: buyerEmail,
        name: eventName,
        schedules,
        ...rest
      } = action.data.data;
      const pickupSchedule = getSanitizedSchedule(schedules);

      return {
        ...state,
        ...rest,
        pending: false,
        pickupSchedule,
        buyerEmail,
        eventName,
      }
    }

      case `${constants.SEND_PICKUP_DATA}_ENDED`:
          const {
              schedules,
              ...rest
          } = action.data.data;
          const pickupSchedule = getSanitizedSchedule(schedules);

          return { ...state, ...rest, pending: false, isSuccesMessageVisible: true, pickupSchedule}

    case `${constants.PROPOSE_NEW_TIME}_ENDED`: {
      return {...state, ...action.data.data, pending: false}
    }

    case constants.SET_TIME_PROPOSAL_MODE:
      return {...state, isTimeProposal: true};

    case constants.TOGGLE_SUCCESS_MESSAGE:
      return {...state, isSuccesMessageVisible: action.data};
    default:
      return state;
  }
}

export default createSchedule